// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.optionList {
  display: grid;
  grid-template-columns: 1fr;
  /* Every card matches the tallest one, so a wrapped answer doesn't
     leave its neighbours looking short. */
  grid-auto-rows: 1fr;
  gap: 0.7rem;
  width: 100%;
}

.optionList.twoCol {
  grid-template-columns: 1fr 1fr;
}

/* A trailing odd option stretches across both columns. */
.optionList.twoCol > .radiobtn:last-child:nth-child(odd) {
  grid-column: 1 / -1;
}

@media (max-width: 600px) {
  .optionList.twoCol {
    grid-template-columns: 1fr;
  }
}

.radiobtn {
  position: relative;
  display: flex;
  min-width: 0;
}

.radiobtn label {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.9rem;
  background: var(--white);
  color: var(--ink);
  border-radius: var(--border-radius);
  padding: 0.6rem 0.75rem;
  border: 2px solid transparent;
  box-shadow: var(--shadow-card);
  cursor: pointer;
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 1.15rem;
  line-height: 1.3;
  text-align: left;
  min-height: 3.6rem;
  box-sizing: border-box;
  transition: border-color 0.12s ease, background-color 0.12s ease, transform 0.12s ease;
  -webkit-tap-highlight-color: transparent;
}

.radiobtn label:hover {
  transform: translateY(-1px);
}

.optionBadge {
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: var(--sky);
  color: var(--ink);
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.35rem;
  line-height: 1;
}

.optionBadge.avatar {
  border-radius: 50%;
  background: var(--sky-strong);
  font-size: 1.2rem;
}

.playerRoom.team2 .optionBadge.avatar,
.rightTeamContainer .optionBadge.avatar {
  background: var(--pink-soft);
}

.optionText {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
}

.optionCheck {
  flex-shrink: 0;
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 50%;
  background: var(--navy);
  opacity: 0;
  transform: scale(0.6);
  transition: opacity 0.12s ease, transform 0.15s var(--bounce-effect);
  position: relative;
}

.optionCheck::after {
  content: "";
  position: absolute;
  left: 0.62rem;
  top: 0.32rem;
  width: 0.45rem;
  height: 0.85rem;
  border-right: 3px solid var(--white);
  border-bottom: 3px solid var(--white);
  transform: rotate(45deg);
}

.radiobtn input[type="radio"] {
  display: none;
  position: absolute;
  width: 100%;
  appearance: none;
}

.radiobtn input[type="radio"]:checked + label {
  border-color: var(--navy);
  background: #eef8fe;
}

.radiobtn input[type="radio"]:checked + label .optionCheck {
  opacity: 1;
  transform: scale(1);
}

.radiobtn input[type="radio"]:disabled + label {
  cursor: default;
}

.radiobtn input[type="radio"]:disabled + label:hover {
  transform: none;
}

.radiobtn input[type="radio"]:disabled:not(:checked) + label {
  opacity: 0.75;
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/room/shared/radio-group.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0BAA0B;EAC1B;0CACwC;EACxC,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA,yDAAyD;AACzD;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,mCAAmC;EACnC,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,sFAAsF;EACtF,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,qBAAqB;EACrB,oEAAoE;EACpE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".optionList {\n  display: grid;\n  grid-template-columns: 1fr;\n  /* Every card matches the tallest one, so a wrapped answer doesn't\n     leave its neighbours looking short. */\n  grid-auto-rows: 1fr;\n  gap: 0.7rem;\n  width: 100%;\n}\n\n.optionList.twoCol {\n  grid-template-columns: 1fr 1fr;\n}\n\n/* A trailing odd option stretches across both columns. */\n.optionList.twoCol > .radiobtn:last-child:nth-child(odd) {\n  grid-column: 1 / -1;\n}\n\n@media (max-width: 600px) {\n  .optionList.twoCol {\n    grid-template-columns: 1fr;\n  }\n}\n\n.radiobtn {\n  position: relative;\n  display: flex;\n  min-width: 0;\n}\n\n.radiobtn label {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.9rem;\n  background: var(--white);\n  color: var(--ink);\n  border-radius: var(--border-radius);\n  padding: 0.6rem 0.75rem;\n  border: 2px solid transparent;\n  box-shadow: var(--shadow-card);\n  cursor: pointer;\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: 1.15rem;\n  line-height: 1.3;\n  text-align: left;\n  min-height: 3.6rem;\n  box-sizing: border-box;\n  transition: border-color 0.12s ease, background-color 0.12s ease, transform 0.12s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.radiobtn label:hover {\n  transform: translateY(-1px);\n}\n\n.optionBadge {\n  flex-shrink: 0;\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 10px;\n  display: grid;\n  place-items: center;\n  background: var(--sky);\n  color: var(--ink);\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.35rem;\n  line-height: 1;\n}\n\n.optionBadge.avatar {\n  border-radius: 50%;\n  background: var(--sky-strong);\n  font-size: 1.2rem;\n}\n\n.playerRoom.team2 .optionBadge.avatar,\n.rightTeamContainer .optionBadge.avatar {\n  background: var(--pink-soft);\n}\n\n.optionText {\n  flex: 1;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.optionCheck {\n  flex-shrink: 0;\n  width: 1.9rem;\n  height: 1.9rem;\n  border-radius: 50%;\n  background: var(--navy);\n  opacity: 0;\n  transform: scale(0.6);\n  transition: opacity 0.12s ease, transform 0.15s var(--bounce-effect);\n  position: relative;\n}\n\n.optionCheck::after {\n  content: \"\";\n  position: absolute;\n  left: 0.62rem;\n  top: 0.32rem;\n  width: 0.45rem;\n  height: 0.85rem;\n  border-right: 3px solid var(--white);\n  border-bottom: 3px solid var(--white);\n  transform: rotate(45deg);\n}\n\n.radiobtn input[type=\"radio\"] {\n  display: none;\n  position: absolute;\n  width: 100%;\n  appearance: none;\n}\n\n.radiobtn input[type=\"radio\"]:checked + label {\n  border-color: var(--navy);\n  background: #eef8fe;\n}\n\n.radiobtn input[type=\"radio\"]:checked + label .optionCheck {\n  opacity: 1;\n  transform: scale(1);\n}\n\n.radiobtn input[type=\"radio\"]:disabled + label {\n  cursor: default;\n}\n\n.radiobtn input[type=\"radio\"]:disabled + label:hover {\n  transform: none;\n}\n\n.radiobtn input[type=\"radio\"]:disabled:not(:checked) + label {\n  opacity: 0.75;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
